import { createApiRef } from '@backstage/core-plugin-api';
import type {
  RithumAgentOptionsResponse,
  RithumAgentStartTaskInput,
} from './types';

export interface RithumAgentApi {
  startTask(input: RithumAgentStartTaskInput): Promise<{
    message: string;
    workflowRunUrl?: string;
  }>;
  getOptions(): Promise<RithumAgentOptionsResponse>;
}

export const rithumAgentApiRef = createApiRef<RithumAgentApi>({
  id: 'plugin.rithum-agent.service',
});
